// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__sLtrX","nav__list":"Navigation_nav__list__y8XSB","nav__link":"Navigation_nav__link__P1Kqj"};